import MarkdownIt from 'markdown-it';
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-light.min.css';

const markdown = new MarkdownIt({})

export default {
  install: function(Vue) {
    const defaultOptions = {
      linkify: false,
      breaks: false,
      html: false,
      highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(str.trim(), { language: lang }).value;
          } catch (__) {}
        }

        const esc = markdown.utils.escapeHtml;
        return `<pre><code class="hljs">${esc(lang)}\n${esc(str)}</code></pre>`;
      }
    };

    Vue.prototype.$md = function(text, customOptions = {}) {
      const options = Object.assign({}, defaultOptions, customOptions);
      const md = new MarkdownIt(options)
      return md.render(text);
    };
  }
}
